import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const repairStatusesAdapter = getAdapter({ idFieldName: 'value' });

const repairStatusesSlice = createSlice({
  name: 'repairStatuses',
  initialState: repairStatusesAdapter.getInitialState(),
  reducers: {
    setRepairStatuses: (state, { payload: { repairStatuses } }) => {
      repairStatusesAdapter.setAll(state, repairStatuses);
    },
  },
});

const selectors = repairStatusesAdapter.getSelectors(({ repairStatuses }) => repairStatuses);

export const getRepairStatuses = (state) => selectors.selectAll(state);

export const {
  setRepairStatuses,
} = repairStatusesSlice.actions;

export default repairStatusesSlice.reducer;
